 
import Feature from 'ol/Feature';
import { Point } from 'ol/geom';
import { adressSearch } from './adressSearch';
import { ScoreableSearchResult } from '../interfaces';
import { gstkSearch } from './gstkSearch';


/**
    * Sorts an array of json values by its score descending.
    * @param values The values to be sorted
    */
export const sortByScore = (values: ScoreableSearchResult[]) => values.sort((n1, n2) => n2.score - n1.score);


export const parseSearchResults2Feature = (searchResult: ScoreableSearchResult) => {
    let feature = new Feature<Point>({
        geometry: new Point(searchResult.centroid),
        layer: searchResult.layer,
        label: searchResult.label,
    });
    feature.setId(searchResult.id);
    return feature;
}



export const parseSearchResults2Features = (searchResult: ScoreableSearchResult[]) =>
    searchResult.map(entry => parseSearchResults2Feature(entry));



/**
 * Searchs within the visible layers.
 * @param query The query
 * @returns The matching search hits.
 */
export const searchLayers = (query: string, limit = 20) =>

    new Promise<ScoreableSearchResult[]>((resolve, reject) =>
        Promise.all<ScoreableSearchResult[]>([adressSearch(query, limit), gstkSearch(query,limit)]).then((searchResults) => {
            console.log(searchResults);
            let searchResult: ScoreableSearchResult[] = [];
            searchResults.forEach(result => searchResult = searchResult.concat(result));
            searchResult = sortByScore(searchResult);
            resolve(searchResult.slice(0, limit));
        }).catch(e => reject(e)));






